import { useSelector } from 'react-redux';

import locale from '../../utils/localization.json';

const ObjectCardItemToggle = ({ isDisabled, isChecked, hidden, handleToggleChange }) => {
    const lang = useSelector((state) => state.language);

    const labelClassName = `relative inline-flex items-center ${
        hidden ? 'cursor-pointer' : ''
    }`;

    return (
        <>
            <div className="text-modelic-gray-100 text-xs font-medium font-poppins leading-3">
                {locale[lang].rgb}
            </div>
            <label className={labelClassName}>
                <input
                    id="switch-3"
                    type="checkbox"
                    className="peer sr-only"
                    disabled={isDisabled}
                    checked={isChecked}
                    onChange={handleToggleChange}
                />
                <label htmlFor="switch-3" className="hidden"></label>{' '}
                <div className="peer h-3 w-10 rounded border bg-modelic-gray-700 after:absolute after:-top-1 after:left-0 after:h-5 after:w-5 after:rounded-md after:border after:border-modelic-gray-700 after:bg-modelic-gray-100 after:transition-all after:content-[''] peer-checked:bg-modelic-primary-light peer-checked:after:translate-x-full peer-focus:ring-modelic-primary-light"></div>
            </label>
            <div className="text-modelic-gray-100 text-xs font-medium font-poppins leading-3">
                {locale[lang].distance}
            </div>
        </>
    );
};

export default ObjectCardItemToggle;
